import HttpService from './http'

// HTTP client (for RouteLeaf API)
const baseUrl = process.env.VUE_APP_DATA_API_BASE_URL

export const routeLeafApi = new HttpService({
  debug: false,
  baseUrl
})
